import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";

import { WtaPublisherAppStore } from "./core/redux/reduxStore";

const RESIZE_OBSERVER_WARNING =
  "ResizeObserver loop completed with undelivered notifications.";

// Run ResizeObserver work on the next animation frame to avoid browser
// resize loop warnings from measured UI components in development.
if (typeof window !== "undefined" && "ResizeObserver" in window) {
  const NativeResizeObserver = window.ResizeObserver;

  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

// CRA's runtime overlay can promote this browser warning to a red error
// screen in development, so suppress that specific event as early as possible.
window.addEventListener(
  "error",
  (event) => {
    if (
      event.message === RESIZE_OBSERVER_WARNING ||
      event.error?.message === RESIZE_OBSERVER_WARNING
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true
);

window.onerror = (message, ...rest) => {
  if (message === RESIZE_OBSERVER_WARNING) {
    return true;
  }

  return false;
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={WtaPublisherAppStore}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
